import { useContext } from 'react';
import { PmpConfigContext } from '@pmp/contexts';

/**
 * Custom hook to check if all specified feature toggles are enabled.
 * @param features - Array of feature toggle names to check.
 * @returns boolean - True if all specified features are enabled, false otherwise.
 */
export const useFeatureToggle = (features: string[]) => {
  const { featureToggles } = useContext(PmpConfigContext);

  return featureToggles && features.every(feature => featureToggles[feature as keyof typeof featureToggles]);
};

/**
 * Custom hook to retrieve all feature toggles.
 * @returns Object - The feature toggles configuration.
 */
export const useFeatureToggles = () => {
  const { featureToggles } = useContext(PmpConfigContext);

  return featureToggles;
};
